// @flow
import { connect } from 'react-redux';
import { fetchAllLogsRequest } from 'redux/Machine/actions';
import { allLogs, alertLogs } from 'redux/Machine/selectors';
import Logs from './LogsDashboard.component';
import type { DispatchPropsType, StatePropsType } from './LogsDashboard.component';

const mapStateToProps = (state: StoreType): StatePropsType => ({
  logs: allLogs(state),
  alertLogs: alertLogs(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchAllLogsRequest: (logType: string, id: number) => dispatch(fetchAllLogsRequest(logType, id)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Logs): any);
